export const formUrlObject = (urlData) => {
  let formedURL = [];

  for (let i in urlData) {
    let obj = {};

    obj['status'] = urlData[i].url_meta_data.is_reviewed ? 1 : 0;
    obj['revised_category'] = urlData[i].revised_category ?
      urlData[i].revised_category.detailed_category_name : null;
    obj['row_id'] = parseInt(i) + 1;
    obj['id'] = urlData[i].id;
    obj['url_metadata_id'] = urlData[i].url_meta_data.id;
    obj['normalized_url'] = urlData[i].url_meta_data.normalized_url;
    obj['image_s3_location'] = urlData[i].url_meta_data.image_s3_location;
    obj['last_updated_timestamp'] = urlData[i].url_meta_data.last_updated_timestamp
      .replace('T', ' ')
      .replace(/\.[0-9]*Z/i, "");
    obj['meta_data_s3_location'] = urlData[i].url_meta_data.meta_data_s3_location;
    obj['page_source_s3_location'] = urlData[i].url_meta_data.page_source_s3_location;
    obj['prevalence_info'] = urlData[i].url_meta_data.prevalence_info ?
      urlData[i].url_meta_data.prevalence_info : 'None';
    obj['tag'] = urlData[i].url_meta_data.tags ? urlData[i].url_meta_data.tags : 'None';
    obj['score'] = urlData[i].score;
    obj['original_category'] = urlData[i].original_category[0] ?
      urlData[i].original_category[0] : 'None'
    obj['all_categories'] = urlData[i].original_category
    formedURL.push(obj);
  };

  return formedURL;
};

export const setIsReviewedStatus = ({ urls, id }) => {
  let updatedURLs = urls.map((url) => { if (url.row_id == id) url.status = 1; return url; });
  return updatedURLs;
};

export const setIsIgnoredStatus = ({ urls, id }) => {
  let updatedURLs = urls.map((url) => { if (url.row_id == id) url.status = 2; return url; });
  return updatedURLs;
};

export const filterIgnoredUrls = (urls) => {
  let updatedURLs = urls.filter((url) => url.status != 2);
  updatedURLs = updatedURLs.map(({ row_id, ...urls }, index) => ({ ...urls, row_id: index + 1 }));
  return updatedURLs;
};

export const formatStatusTableData = (data) => {
  let formattedData = data.map(({ ...others }, index) => ({ ...others, row_id: index + 1 }));
  return formattedData;
};

export const updateRevisedCategory = ({ urls, id, revisedCategory }) => {
  let updatedURLs = urls.map((url) => { if (url.row_id == id) url.revised_category = revisedCategory; return url; });
  return updatedURLs;
};
